
import superagent from "superagent";
import { authorize_onboarding, authorize } from "../../helper/authorize-token";
import { deep_copy, deep_update} from "../../../lib/js-utils";
import { sprintf } from "sprintf-js";
import { UGMA_INVITE_ID_FORMAT } from "../../../lib/constants";
import {StatementTypes} from "../../../lib/statement-constants";

const USER_SET_LOADING = "USER_SET_LOADING";
const USER_UGMA_INVITES_LOADING = "USER_UGMA_INVITES_LOADING";
const USER_LOAD_DASHBOARD = "USER_LOAD_DASHBOARD";
const USER_LOAD_UGMA_DASHBOARD = "USER_LOAD_UGMA_DASHBOARD";
const USER_CLEAR_DASHBOARD = "USER_CLEAR_DASHBOARD";
const USER_UGMA_ADD_INVITE = "USER_UGMA_ADD_INVITE";
const USER_SET_UGMA_ITEM = "USER_SET_UGMA_ITEM";
const USER_LOAD_STATEMENTS = "USER_LOAD_STATEMENTS";
const USER_STATEMENTS_CURRENT_YEAR = "USER_STATEMENTS_CURRENT_YEAR";

const addUGMAInvite = (username, index, item_index) => {
  return (dispatch) => {
    dispatch({
      type: USER_UGMA_ADD_INVITE,
      username,
      index,
      new_id: sprintf(UGMA_INVITE_ID_FORMAT, item_index),
      item_index: item_index,
    })
  }
}

const loadUGMADashboard = (username, acct_index, wlf_id) => {
  return (dispatch, getState) => {
    dispatch({
      type: USER_UGMA_INVITES_LOADING,
      loading: true,
    });
    dispatch({
      type: USER_LOAD_UGMA_DASHBOARD,
      payload: superagent
        .post("/api/dashboard/ugma-invites")
        .use(authorize(getState().user.token))
        .send({ username, acct_index, wlf_id }),
    })
  }
};

const sendWireInstructions = (token, onboarding_token, username, index) => {

  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/email/send-wire-instructions")
      .use(authorize_onboarding(token, onboarding_token))
      .send({ username, index })
      .then(res => {
        return resolve();
      })
  });
}

const sendCheckInstructions = (token, onboarding_token, username, index) => {

  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/email/send-check-instructions")
      .use(authorize_onboarding(token, onboarding_token))
      .send({ username, index })
      .then(res => {
        return resolve();
      })
  });
}

const sendUGMAInvite = (
  token, username, acct_index, first_name, last_name,
  email, relationship, invite_index, wlf_id) => {

  return new Promise((resolve) => {
    return superagent.agent()
      .post("/api/email/ugma-invite")
      .use(authorize(token))
      .send({ username, acct_index, first_name, last_name, email,
        relationship, invite_index, wlf_id})
      .then(res => {
        return resolve(res.body.data);
      })
  })
}

const setUGMAItem = (username, acct_index, item) => {
  return dispatch => {
    dispatch({
      type: USER_SET_UGMA_ITEM,
      username,
      acct_index,
      item,
    })
  }
}

const UGMAContributionSent = (
  token, inviter_username, inviter_index, invite_id) => {

  return new Promise((resolve) => {
    return superagent.agent()
      .post("/api/email/ugma-contribution-sent")
      .use(authorize(token))
      .send({ inviter_username, inviter_index, invite_id })
      .then(resolve);
  });
}

const loadAccountData = (username, acct_index, date, chart_colors) => {
  return (dispatch, getState) => {
    dispatch({
      type: USER_SET_LOADING,
      loading: true,
    })
    dispatch({
      type: USER_LOAD_DASHBOARD,
      payload: superagent
        .post("/api/dashboard/account")
        .use(authorize_onboarding(
          getState().user.token,
          getState().user.onboarding_token))
        .send({
          id: username,
          acct_index,
          date,
          chart_colors})
    })
  }

};

const clearUserDashboard = () => {
  return dispatch => {
    dispatch({
      type: USER_CLEAR_DASHBOARD,
    })
  }
}

const userLoadStatements = (acct_index, username) => {

  return (dispatch, getState) => {
    dispatch({
      type: USER_SET_LOADING,
      loading: true,
    })
    dispatch({
      type: USER_LOAD_STATEMENTS,
      payload: superagent
        .post("/api/dashboard/statements")
        .use(authorize_onboarding(
          getState().user.token,
          getState().user.onboarding_token))
        .send({ acct_index, username }),
    })
  }
}

const loadStatement = (token, statement_type, year, month, index, username) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/dashboard/get-statement")
      .use(authorize(token))
      .send({ statement_type, year, month, index, username })
      .then(result => {
        return resolve(result.body.data);
      });
  })
}

const getUserInfo = (token, onboarding_token, acct_index, info_update, username) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/onboarding/get-user-info")
      .use(authorize_onboarding(token, onboarding_token))
      .send({ username, info_update, acct_index })
      .then(result => {
        return resolve(result.body.data);
      })
  })
}

const setUserEndDate = async (token, username, index, endDate, maturityYears) => {
    const response = await superagent.agent()
        .post("/api/dashboard/admin-set-user-end-date")
        .use(authorize_onboarding(token))
        .send({ username, index, endDate, maturityYears });

    return response.body;
}

const getUserMaturityHistory = async (token, username, index) => {
    const response = await superagent.agent()
        .post("/api/dashboard/admin-get-user-maturity-history")
        .use(authorize(token))
        .send({ username, index });
    
    return response.body;
}

const setUserRisk = async (token, username, index, risk) => {
    const response = await superagent.agent()
        .post("/api/dashboard/admin-set-user-risk")
        .use(authorize(token))
        .send({ username, index, risk});

    return response.body;
}

const getPotentialReport = (token, username, accountIndex) => {
    return new Promise((resolve, reject) => {
        return superagent.agent()
            .post("/api/dashboard/calc-portfolio-analysis")
            .use(authorize(token))
            .send({ username, accountIndex })
            .then(result => {
                return resolve(result.body.payload);
            })
    })
}

const setStatementCurrentYear = (username, index, statement_type, year) => {
  return dispatch => {
    dispatch({
      type: USER_STATEMENTS_CURRENT_YEAR,
      username,
      index,
      statement_type,
      year,
    })
  }
}

const userDashboardReducer = (
  state = { loading: false, ugma_loading: false }, action) => {

  let data, key, username, acct_key, path;
  let new_state = deep_copy(state);

  switch (action.type) {
    case USER_SET_LOADING:
      new_state.loading = action.loading;
      return new_state;

    case USER_SET_UGMA_ITEM:
      key = sprintf("%04d", action.acct_index);
      username = action.username;
      const index = new_state[username][key].ugma_invites.findIndex(
        item => item.index === action.item.index);
      new_state[username][key].ugma_invites[index] = action.item;
      return new_state;

    case USER_UGMA_INVITES_LOADING:
      new_state.ugma_loading = action.loading;
      return new_state;

    case USER_CLEAR_DASHBOARD:
      return { loading: false };

    case USER_UGMA_ADD_INVITE:
      key = sprintf("%04d", action.index);
      username = action.username;
      if (!new_state[username][key].ugma_invites) {
        new_state[username][key].ugma_invites = [];
      }
      new_state[username][key].ugma_invites.push({
        id: action.new_id,
        new_invite: true,
        index: action.item_index,
        can_send: false,
      });
      return new_state;
    case USER_LOAD_DASHBOARD + "_FULFILLED":
      data = action.payload.body.data
      acct_key = data.acct_index === -1 ? "ALL" : sprintf("%04d", data.acct_index);
      path = [ data.username, acct_key ];
      deep_update(new_state, path, data);
      new_state.loading = false;
      return new_state;
    case USER_LOAD_UGMA_DASHBOARD + "_FULFILLED":
      data = action.payload.body.data;
      key = sprintf("%04d", data.index);
      username = data.username;
      deep_update(
        new_state,
        [ username, key ],
        { ugma_invites: data.items });
      new_state.ugma_loading = false;
      return new_state;

    case USER_STATEMENTS_CURRENT_YEAR:
      key = sprintf("%04d", action.index);
      if (action.statement_type === StatementTypes.MONTHLY) {
        deep_update(
          new_state,
          [action.username, key ],
          { current_year: action.year});
      } else if (action.statement_type === StatementTypes.TRADE_CONFIRMATIONS) {
        new_state.current_trade_confirmations = action.year;
        deep_update(
          new_state,
          [action.username, key ],
          { current_year: action.year});
      }
      return new_state;
    case USER_LOAD_STATEMENTS + "_FULFILLED":
      new_state.loading = false;
      data = action.payload.body.data;
      if (!data) {
        return new_state;
      }
      key = sprintf("%04d", data.acct_index);
      username = data.username;
      const curr_monthly = data.monthly.length > 0
        ? data.monthly[0].year : new Date().getFullYear();
      const curr_trade = data.trade_confirmations.length > 0
        ? data.trade_confirmations[0].year: new Date().getFullYear();
      deep_update(new_state,
        [username, key],
        {
          current_year: Math.max(curr_monthly, curr_trade),
          current_monthly: data.monthly.length > 0
            ? data.monthly[0].year : new Date().getFullYear(),
          current_trade_confirmations: data.trade_confirmations.length > 0
            ? data.trade_confirmations[0].year: new Date().getFullYear(),
          monthly: data.monthly,
          '1099': data['1099'],
          trade_confirmations: data.trade_confirmations,
        })
      return new_state;
    default:
      return state;
  }
};

export { userDashboardReducer, loadAccountData, clearUserDashboard,
  loadUGMADashboard, addUGMAInvite, sendUGMAInvite, setUGMAItem,
  UGMAContributionSent, userLoadStatements, loadStatement,
  setStatementCurrentYear, getUserInfo, sendWireInstructions,
  sendCheckInstructions, getPotentialReport, setUserEndDate, getUserMaturityHistory,
  setUserRisk
};
